import { render, staticRenderFns } from "./CompleteLifeStage.vue?vue&type=template&id=1ccf72bc&scoped=true&"
import script from "./CompleteLifeStage.vue?vue&type=script&lang=js&"
export * from "./CompleteLifeStage.vue?vue&type=script&lang=js&"
import style0 from "./CompleteLifeStage.vue?vue&type=style&index=0&id=1ccf72bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccf72bc",
  null
  
)

export default component.exports